import { Injectable } from '@angular/core';
import { API_MAP } from 'app/core/helpers/api.map';
import { Result } from 'app/core/models/result';
import { BaseDataService } from 'app/core/services/base-data.service';
import { Observable, tap } from 'rxjs';
import { Home } from '../models/home';

@Injectable()
export class HomeService extends BaseDataService<Home> {
  override controller = API_MAP.home;

  override get(controller?: string): Observable<Result<Home>> {
    return super.get(controller ?? this.controller).pipe(
      tap((d: any) => {
        this.content.set(d);
        this.components.set(d.components);
      })
    );
  }
}
